import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Mail, ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { forgotPassword } from '@/api/http/auth-api'
import { extractErrorMessage } from '@/api/http/errors'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setEmailError('')

    if (!email.trim()) {
      setEmailError('Введите email')
      return
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setEmailError('Некорректный email')
      return
    }

    setLoading(true)
    try {
      await forgotPassword(email.trim())
      setSent(true)
    } catch (err) {
      setError(extractErrorMessage(err, 'Ошибка отправки'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex items-center justify-center min-h-dvh p-4">
      <div className="w-full max-w-sm mx-auto">
        <div className="flex flex-col items-center mb-8">
          <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-accent to-[#8aa4ff] text-white text-base font-bold mb-4">
            DH
          </div>
          <h1 className="text-xl font-semibold text-text">Восстановление пароля</h1>
        </div>

        <div className="rounded-xl border border-border bg-surface p-6">
          {sent ? (
            <div className="text-center space-y-4">
              <div className="flex justify-center">
                <Mail className="w-12 h-12 text-accent" strokeWidth={1.5} />
              </div>
              <p className="text-sm text-text-muted">
                Если аккаунт существует, письмо отправлено
              </p>
              <Link
                to="/login"
                className="inline-flex items-center gap-1.5 text-sm text-accent hover:text-accent/70 transition-colors"
              >
                <ArrowLeft className="w-4 h-4" strokeWidth={2} />
                Вернуться ко входу
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <p className="text-sm text-text-muted">
                Введите email, привязанный к аккаунту. Мы отправим ссылку для сброса пароля.
              </p>

              <div className="space-y-1.5">
                <label className="text-sm font-medium text-text">
                  Email <span className="text-red">*</span>
                </label>
                <Input
                  type="email"
                  placeholder="mail@example.com"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setEmailError('') }}
                  aria-invalid={!!emailError}
                />
                {emailError && (
                  <p className="text-xs text-red mt-1">{emailError}</p>
                )}
              </div>

              {error && (
                <p className="text-sm text-red text-center">{error}</p>
              )}

              <Button type="submit" className="w-full gap-2" size="lg" disabled={loading}>
                <Mail className="w-4 h-4" strokeWidth={2} />
                {loading ? 'Отправка...' : 'Отправить'}
              </Button>

              <div className="text-center">
                <Link
                  to="/login"
                  className="inline-flex items-center gap-1.5 text-xs text-text-muted hover:text-text transition-colors"
                >
                  <ArrowLeft className="w-4 h-4" strokeWidth={2} />
                  Вернуться ко входу
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  )
}
